import React, { useContext } from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { OrderDetailContext } from 'compositions/OrderDetail/OrderDetailContext';
import { GroupedTiresType, WizardContext } from 'compositions/Wizard/WizardContext';
import { getGroupedTiresFromOrder } from './getGroupedTires';

interface ComboResumeProps {
  mspn: string;
}
export function ComboResume(props: ComboResumeProps) {
  const { t } = useTranslation();
  const { mspn } = props;
  const { groupedParts } = useContext(WizardContext);
  const { order } = useContext(OrderDetailContext);

  let group: GroupedTiresType | undefined;
  if (groupedParts) group = groupedParts.find((p) => p.tireMspn === mspn);
  if (order) group = getGroupedTiresFromOrder(order.parts).find((p) => p.tireMspn === mspn);

  if (!group) return null;

  const tiresQty = group?.tires.reduce((acc, p) => acc + p.qty, 0);

  if (!tiresQty) return null;
  return (
    <div
      style={{
        border: '1px solid',
        marginTop: 16,
        padding: 8,
        paddingTop: 0,
      }}
    >
      <Typography align="center" variant="h6">
        {t(`Added {{prod}}`, {prod: tiresQty === 1 ? 'product' : 'products'})}
      </Typography>
      <Typography variant="body2" align="center">
        {t(
          `{{tiresQty}} {{tire}} with {{qty}} {{config}}`, {tiresQty, configQty: group.tires.length, tire: tiresQty === 1 ? 'tire' : 'tires', config: group.tires.length === 1 ? 'configuration' : 'configurations'}
        )}
      </Typography>
    </div>
  );
}
